import React from 'react';
import * as S from './PersuasionTag.styles';

const PersuasionTag = ({ ptag }) => {

    const PERSUASION_TAG = `People choice for`
    const greenStarIcon = "https://gos3.ibcdn.com/green_star-1645531773.png";

    return (
        <>
            {ptag && ptag.length > 0 ?
                <S.PersuasionTag>
                    <span><img src={greenStarIcon} />{PERSUASION_TAG}</span>
                    <ul>
                        {ptag.slice(0, 5).map(item => (
                            <S.Contanier key={item?.id}>
                                <span>{'\u2022'} {item?.title}</span>
                            </S.Contanier>
                        ))}
                    </ul>

                </S.PersuasionTag>
                : <></>
            }</>
    )
}

export default PersuasionTag;
